import { MiddlewareArgs } from "../method-proxy"

const fsReadMethods = new Set<string | number | symbol>([
	"readdir",
	"readFile",
	"readlink",
	"realpath",
	"lstat",
	"stat"
]);

type reaction = (actionPromise: Promise<any>) => void;

type FsSensorProps = {
	observers?: reaction[] | reaction;
};

export class FsSensor {
	observers: Set<(actionPromise: Promise<any>) => void>;

	constructor({ observers = [] }: FsSensorProps = {}) {
		const reactions = Array.isArray(observers) ? observers : [observers];
		this.observers = new Set<(actionPromise: Promise<any>) => void>(reactions);
	}

	middleware = ({ targetResult, propKey }: MiddlewareArgs) => {
		//no sure we want these
		if (fsReadMethods.has(propKey)) {
			return targetResult;
		}

		const promise = Promise.resolve(targetResult);

		this.triggerCallbacks(promise);

		return targetResult;
	};

	private triggerCallbacks(promise: Promise<any>) {
		this.observers.forEach(c => c(promise));
	}
}
